// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/revivers')

class RecReasonRecord extends Immutable.Record({
  html: String(),
  items: Immutable.List(),
  template: String()
}) {
  // No methods
}

RecReasonRecord.reviver = keyedReviver(RecReasonRecord, {
  items: defaultReviver
})

RecReasonRecord.propTypes = {
  html: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  template: PropTypes.string
}

module.exports = RecReasonRecord
